import { render, staticRenderFns } from "./cardArea.vue?vue&type=template&id=523331e0&scoped=true&"
import script from "./cardArea.vue?vue&type=script&lang=js&"
export * from "./cardArea.vue?vue&type=script&lang=js&"
import style0 from "./cardArea.vue?vue&type=style&index=0&id=523331e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523331e0",
  null
  
)

export default component.exports